__turbopack_context__.v({
  "artPiece": "index-module-scss-module__7Qy_YG__artPiece",
  "imgModal": "index-module-scss-module__7Qy_YG__imgModal",
  "modal": "index-module-scss-module__7Qy_YG__modal",
  "modalInfo": "index-module-scss-module__7Qy_YG__modalInfo",
  "noScroll": "index-module-scss-module__7Qy_YG__noScroll",
  "opeenModal": "index-module-scss-module__7Qy_YG__opeenModal",
  "openModal": "index-module-scss-module__7Qy_YG__openModal",
  "slideIn": "index-module-scss-module__7Qy_YG__slideIn",
  "slideOut": "index-module-scss-module__7Qy_YG__slideOut",
});
